/*
 * @Author: bill
 * @Date: 2023-03-14 09:51:23
 * @LastEditors: wangzijun@bzstech.com wangzijun@bzstech.com
 * @LastEditTime: 2024-06-20 13:57:19
 * @FilePath: /study/src/store/modules/base.ts
 * @Description:
 */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "../index";

interface State {
  token: string;
  dictItems: any;
}

//基本的state
const initialState: State = {
  token:
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhY2NvdW50VHlwZSI6IjMiLCJuZXdVc2VybmFtZSI6Indhbmd6aWp1biIsImlkIjoiMTU1MTQ1NzY1MjUwMzAwMzEzNyIsImV4cCI6MTcxODg1NDM4NiwidXNlcm5hbWUiOiJ3YW5nemlqdW4ifQ.ZxXG76VIhFOemgveSpzVVXwTNyjlBIvzgNc3aTPtSRE",
  dictItems: null,
};
export const rootSlice = createSlice({
  name: "root",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setDictItems: (state, action: PayloadAction<string>) => {
      state.dictItems = action.payload;
    },
  },
});

// 导出action
export const { setToken, setDictItems } = rootSlice.actions;

//异步action demo
export const tokenAsync = (token: string): AppThunk => {
  return async (dispatch) => {
    setTimeout(() => {
      dispatch(setToken(token));
    }, 2000);
  };
};

// 导出reducer
export default rootSlice.reducer;
